module.exports = __webpack_public_path__ + "static/media/SemenukPic.7446d776.jpg";